import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { FaWhatsapp, FaYoutube } from "react-icons/fa";
import w from "../../assets/w.png";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import "./Styles/salesSolution.css";
import Alert from "../../assets/Alert_Icon.png";
import "bootstrap/dist/css/bootstrap.css";
import Catalogsolutions from "../../assets/solutions/catalog_solutions.png";
import Footer from "../../components/footer/footer";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";

export const CatalogSolution = () => {
  const [colorChange, setColorchange] = useState(false);
  const [show, setShow] = useState(false);
  const [MailSentShow, setMailSentShow] = useState(false);
  const [ContactShow, setContactShow] = useState(false);
  const [FailedContactShow, setFailedContactShow] = useState(false);

  const ContacthandleClose = () => setContactShow(false);
  const ContacthandleShow = () => setContactShow(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const FailedPhonehandleClose = () => setFailedContactShow(false);
  const FailedPhonehandleShow = () => setFailedContactShow(true);

  const EmailHandleClose = () => setMailSentShow(false);
  const EmailHandleShow = () => setMailSentShow(true);

  const [name, setName] = useState("");
  const [Contact, setContact] = useState("");

  const handleChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setContact(event.target.value);
  };

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);
  //className={colorChange ? 'navbar colorChange' : 'navbar'}
  const [nav, setnav] = useState(false);
  const navigate = useNavigate();

  const changeBackground = () => {
    if (window.scrollY >= 50) {
      setnav(true);
    } else {
      setnav(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  const [mailerState, setMailerState] = useState({
    email: "",
  });

  function handleStateChange(e) {
    setMailerState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    sessionStorage.setItem("UserEmail", mailerState.email);
  }

  const submitEmail = async (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      to: [
        {
          email: mailerState.email,
          name: "MAPO International",
        },
      ],
      templateId: 0,
      headers: {
        "X-Mailin-custom":
          "custom_header_1:custom_value_1|custom_header_2:custom_value_2|custom_header_3:custom_value_3",
        charset: "iso-8859-1",
      },
    });
    console.log({ mailerState });
    const response = await fetch("https://api.brevo.com/v3/smtp/email", {
      method: "post",
      headers: {
        "api-key":
          "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",
        "Content-Type": "application/json",
      },
      body: data,
    })
      .then((response) =>
        response.json().then((res) => ({ status: response.status, data: res }))
      )
      .then((apiResponse) => {
        console.log("e 1", apiResponse);
        if (apiResponse.status === 201) {
           
           ContacthandleShow();
        } else if (apiResponse.status === 400) {
          handleShow();
        }
      })
      .catch((error) => {
        console.error("Error: 2", error);
      })
      .then(() => {
        setMailerState({
          email: "",
        });
      });
  };

  const ContactUpdate = async (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      attributes: { FIRSTNAME: name, SMS: Contact },
      updateEnabled: true,

      //email: "giggslivwwe@gmail.com",
      email: sessionStorage.getItem("UserEmail"),
    });
    console.log({ mailerState });
    const response = await fetch("https://api.brevo.com/v3/contacts", {
      method: "post",
      headers: {
        "api-key":
          "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",
        "Content-Type": "application/json",
      },
      body: data,
    })
      .then((response) =>
        response.json().then((res) => ({ status: response.status, data: res }))
      )
      .then((apiResponse) => {
        console.log("e 1", apiResponse);
        if (apiResponse.status === 201) {
          // EmailHandleShow();
          ContacthandleClose();
          EmailHandleShow();
        } else if (apiResponse.status === 400) {
          //handleShow();
          FailedPhonehandleShow();
        }
      })
      .catch((error) => {
        console.error("Error: for contact func", error);
      });
  };

  return (
    <>
      <nav className={"nav active"}>
        <Link to="/" className="logo" smooth={true} duration={250}>
          <img src={w} alt="logo.png" />
        </Link>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" for="menu-btn">
          <span className="nav-icon"></span>
        </label>
        <ul className="menu">
          <li>
            <Link
              onClick={() => navigate("/")}
              to="About"
              smooth={true}
              duration={250}
            >
              Home
            </Link>
          </li>
          <li>
            <a smooth={true} duration={250}>
              <Link
                onClick={() => navigate("/")}
                to="About"
                smooth={true}
                duration={250}
              >
                About
              </Link>
            </a>
          </li>
          <li>
            <Link
              onClick={() => navigate("/")}
              to="Services"
              smooth={true}
              duration={250}
            >
              Services
            </Link>
          </li>
          <li>
            <Link
              onClick={() => navigate("/")}
              to="Industries"
              smooth={true}
              duration={250}
            >
              Industries
            </Link>
          </li>
          <li>
            <Link
              onClick={() => navigate("/")}
              to="Solutions"
              smooth={true}
              duration={250}
            >
              Solutions
            </Link>
          </li>
          <li>
            <Link
              onClick={() => navigate("/")}
              to="International"
              smooth={true}
              duration={250}
            >
              International
            </Link>
          </li>
          <li>
            <Link
              onClick={() => navigate("/")}
              to="Contact"
              smooth={true}
              duration={250}
            >
              Contact us
            </Link>
          </li>
        </ul>
      </nav>

      <div className="container Salesdiv">
        <img alt="blog" src={Catalogsolutions} class="ModalIcon" />
        <span class="fw-400">
          <b>CATALOG Solution</b>
        </span>
        <br />
        <br />
        <div className="ModalSize">
          <p className="TextStyle">CATALOG Solution</p>
          <img alt="blog" src={Alert} className="AlertIcon" />
          <p className="TextStyle">The solution is still under construction</p>
          <br />
          <br />
          <div className="formModalFleet">
            <h1 class="title-h p-relative">
              <span class="fw-200">Get More </span> Information
              <span class="line p-absolute bg-orange"></span>
            </h1>
            <br />
            <form  className="InputField" action="" onSubmit={submitEmail}>
              <label for="email">Email Address</label>
              <input
                type="text"
                placeholder="Email"
                onChange={handleStateChange}
                name="email"
                value={mailerState.email}
                required
              />

              <input
                type="submit"
                // onClick={SendEmailTemplat}
                value="Submit"
              />
            </form>
            <br />
            <br />
            {/* <a href={OemMarketResearchPdf} rel="noopener noreferrer" target="_blank">
              <FaFilePdf color="black" className="SolutionIcon" size={50} />
            </a> */}

            <a
              href="https://www.youtube.com/watch?v=U3peJ_sjVYU"
              target="_blank"
            >
              <FaYoutube color="black" className="SolutionIcon" size={50} />
            </a>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="https://wa.me/27646826775"
        class="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>

      <Modal show={ContactShow} onHide={ContacthandleClose}>
        <Modal.Header closeButton>
          <Modal.Title>We would like to give you a call</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={ContactUpdate}>
            <label for="email">Name</label>
            <input
              type="text"
              placeholder="Name"
              onChange={(e) => handleChange(e)}
              name="email"
              value={name}
              required
            />
            <label for="email">Contact Number</label>
            <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="text"
                      placeholder={`+27`}
                      readOnly
                      style={{
                        marginRight: "10px",

                        width: "54px",
                      }}
                    />
                    <input
                      type="text"
                      placeholder={`9 digits  ${Contact || "e.g 646826775"}`}
                      onChange={(e) => handleEmailChange(e)}
                      name="email"
                      value={Contact}
                      maxLength={9} 
                      required
                    /></div>

            <input type="submit" value="Submit" />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={ContacthandleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Email Not sent</Modal.Title>
          {/* <FaCheck size={25} color="green" className="ModalIcons"/> */}
        </Modal.Header>
        <Modal.Body>
          Make sure the Email is correct:{" "}
          <b>{sessionStorage.getItem("UserEmail")} </b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={MailSentShow} onHide={EmailHandleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Email sent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Email sent to: <b>{sessionStorage.getItem("UserEmail")} </b>
        </Modal.Body>
        <Modal.Footer>
          <span className="Spamfonts">
            Check in Promotions and junk/spam mail
          </span>
          <Button variant="secondary" onClick={EmailHandleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={FailedContactShow} onHide={FailedPhonehandleClose}>
              <Modal.Header closeButton>
                <Modal.Title> Error</Modal.Title>
              </Modal.Header>
              <Modal.Body>Please check Country code :+27</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={FailedPhonehandleClose}>
                  Ok
                </Button>
              </Modal.Footer>
            </Modal>
    </>
  );
};
